module.exports = __webpack_public_path__ + "img/a83cu-6jp7l.5ac0f28b.png";